

export const refresh = (index, orderItems) => dispatch => {
    
    
    const newArray = orderItems.splice(index, 1)
    dispatch({type: CURRENT_USER_SHIPMENTS_UPDATE, currentUserShipments: newArray})
}